import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function PandaGPTLanding() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container product-landing pandagpt-landing">
          <div className="section-header">
            <span className="section-badge">{translate("pandagptBadge", language)}</span>
            <h1 className="product-title pandagpt-title landing-product-title">
              <span>
                <span className="pandagpt-title-text">PandaGPT</span>
                <span className="pandagpt-title-copyright">©</span>
              </span>
            </h1>
            <p className="section-description landing-description">
              {translate("pandagptDescLong", language)}
            </p>
          </div>
          <div className="landing-cta">
            <a
              href={`mailto:support@ygalaad.com?subject=${encodeURIComponent(
                translate("pandagptTitle", language) +
                  " - " +
                  (language === "fr" ? "Contact" : "Contact")
              )}`}
              className="landing-link"
            >
              {translate("contactSupport", language)}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default PandaGPTLanding;
